<!--
 * @Author: 
 * @Date: 2023-12-22 19:21:34
 * @LastEditors: Merlin
 * @LastEditTime: 2024-01-10 10:40:40
 * @Description: 
-->
<template></template>

<script setup lang="ts">
const props = defineProps({
    modelValue: { // 控制是否播放
        type: Boolean, 
        required: true
    },
    audio: { // 音乐实例 new audio
        type: Object as PropType<HTMLAudioElement>,
        required: true
    },
    volume: { // 初始音量
        type: Number,
        required: true
    },
})

const emit = defineEmits(['update:modelValue', 'update:volume'])
const initialVolume = ref(1)
onUnmounted(() => {
    props.audio.pause()
})


// 👇 注释掉，Audio 播放完毕默认情况会自动停止的
// 反之，如果确实需要循环，父级在传入 props.audio 时设为 loop 即可
// onMounted(() => {
//     props.audio.addEventListener('ended', () => {
//         props.audio.currentTime = 0
//         emit('update:modelValue', false)
//     })
//     initialVolume.value = props.audio.volume
// })

watch(() => props.volume, (volume) => {
    let result = volume;
    if (initialVolume.value / 2 < 0.5) {
        result = initialVolume.value * result;
    }

    result = Math.min(1, Math.max(0, result));

    // props.audio.volume = result;
    emit('update:volume', result);
})


</script>